import React from 'react';

const InputFeedback = ({ error, className }) =>
  error ? <small className={'error form-text ' + className}>{error}</small> : null;

export default InputFeedback;
